import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileMediumHeadingControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setTextsHeight(element);
    }

}

const mobileMediumHeadingControlView = new MobileMediumHeadingControlView();
export default mobileMediumHeadingControlView;